import React, { useState, useEffect } from 'react';
import './App.css';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import ws from './common/ws.js';
import moment from 'moment';





import ReactGA from 'react-ga';
ReactGA.initialize('UA-106613014-1');


function MultiForm(props) {

    const [selectOptions, setSelectOptions] = useState({});

    const config = {
        'demo_request': {
            'title': 'Solicitud de Demo',
            'custom_fields': [
                { id: 'pref_date', type: 'date', placeholder: 'Fecha Preferida', label:'Fecha Preferida', required: true, expand: false },
                { id: 'pref_time', type: 'time', placeholder: 'Hora preferida', label:'Hora Preferida', required: true, expand: false },
                { id: 'alt_date', type: 'date', placeholder: 'Fecha Alternativa', label:'Fecha Alternativa', required: true, expand: false },
                { id: 'alt_time', type: 'time', placeholder: 'Hora Alternativa',label:'Hora Alternativa', required: true, expand: false },
                { id: 'comments', type: 'text', placeholder: 'Descripción de sus necesidades', required: true, expand: true },
            ]
        },
        'free_trial_request': {
            'title': 'Iniciar Prueba Gratuita',
            'custom_fields': [
                { id: 'plan', 
                type: 'select', 
                placeholder: 'Plan', 
                required: true, 
                label:"Plan",
                expand:true, 
                options:"state",
                default:props.plan || '2' },
                { id: 'pref_date', type: 'date', placeholder: 'Fecha Preferida', label:'Fecha Preferida', required: true, expand: false },
                { id: 'pref_time', type: 'time', placeholder: 'Hora preferida', label:'Hora Preferida', required: true, expand: false },
                { id: 'alt_date', type: 'date', placeholder: 'Fecha Alternativa', label:'Fecha Alternativa', required: true, expand: false },
                { id: 'alt_time', type: 'time', placeholder: 'Hora Alternativa',label:'Hora Alternativa', required: true, expand: false },
                { id: 'comments', type: 'text', placeholder: 'Descripción de sus necesidades', required: true, expand: true },
            ]
        }
    }
   
    const common_fields = [
        { id: 'name', type: 'char', placeholder: 'Nombre', required: true, expand: false },
        { id: 'company', type: 'char', placeholder: 'Empresa', required: true, expand: false },
        { id: 'email', type: 'email', placeholder: 'Correo electrónico', required: true },
        { id: 'country', type: 'select', placeholder: 'País', required: true, options:"state" },
        { id: 'laboratory_type', type: 'select', placeholder: 'Tipo de Laboratorio', required: true, 
        options:[
            {'id':'', 'name':'Tipo de Laboratorio'},
            {'id':'services', 'name':'Laboratorio de Servicios'},
            {'id':'qc', 'name':'Laboratorio de Control de Calidad'},
        ], expand:true, default:props.lab_type },
        
    ]

    const [fields, setFields] = useState([...common_fields, ...config[props.form_type].custom_fields]);
    const [validation, setValidation] = useState(createValidationSchema());

    

    function createConversionEvent(laboratory_type){
        let conversionEvent = {}

        // conversionEvent.category = props.form_type === 'demo_request' ? 'demo_request':'free_trial_request'

        if(props.form_type === 'demo_request'){
            conversionEvent.category = 'demo_request'
            if(laboratory_type === 'qc'){
                conversionEvent.action = 'qc_demo_request'
                conversionEvent.label = 'QcDemoRequest'
            }
            else if(laboratory_type === 'services'){
                conversionEvent.action = 'services_demo_request'
                conversionEvent.label = 'ServicesDemoRequest'
            }
           

        }

        else if(props.form_type === 'free_trial_request'){
            conversionEvent.category = 'free_trial_request'
            if(laboratory_type === 'qc'){
                conversionEvent.action = 'qc_trial_request'
                conversionEvent.label = 'QcTrialRequest'
            }
            else if(laboratory_type === 'services'){
                conversionEvent.action = 'services_trial_request'
                conversionEvent.label = 'ServicesTrialRequest'
            }
        }

        conversionEvent.value = 1;
        
        return conversionEvent;

      
    }



   

    function getPlanOptions(){
        let plans;
        switch(props.lab_type){
            case 'qc':
                plans =  [{'id':'1','name':'Starter'}, {'id':'2','name':'Premium'}, {'id':'3','name':'Enterprise'}]
                break;
            case 'services':
                plans =  [{'id':'1','name':'Starter'}, {'id':'2','name':'Premium'}, {'id':'3','name':'Enterprise'}]
            
        }

        return plans;

        
    }

    async function getSelectOptions(){
        let new_select = {...selectOptions}
        let countries = await ws.Get('/api/kalenis_web/get_countries',{}, false)
        countries.unshift({"code":0,"id":"","name":"Seleccione País"})
        let plans = getPlanOptions()
        new_select['country'] = countries;
        new_select['plan'] = plans
      
        setSelectOptions(new_select)
    }


    useEffect(() => {
        
       getSelectOptions()
       
        

    }, []);

    function getInitialValues() {
        let values = {}
        fields.forEach(function (field) {
            values[field.id] = field.default || ""
        })
        return values
    }
    

    function createValidationSchema() {
        let rules = {}

        fields.forEach(function (field) {


            if (field.type === 'char' 
                    || field.type === 'date' 
                    || field.type === 'time' 
                    || field.type === 'select'
                    || field.type === 'text') {
                if (field.required) {
                    rules[field.id] = Yup.string()
                        .required('Campo Requerido')
                }
            }
            else if (field.type === 'email') {
                if (field.required) {
                    rules[field.id] = Yup.string()
                        .required('Campo Requerido')
                        .email("Debe ingresar un correo electrónico válido")
                }
                else {
                    rules[field.id] = Yup.string()
                        .email("Debe ingresar un correo electrónico válido")
                }
            }

        })

        return Yup.object().shape(rules);

    }


    function createField(field, errors, touched) {
        let className = "p-2 text-left"
        className = field.expand ? className.concat(' col-lg-12') : className.concat(' col-lg-6')

        let show = "input"
        let type = 'text'
        if (field.type === 'date') {
            type = 'date'
        }
        if(field.type === 'time'){
            type='time'
        }
        if (field.type === "select") {
            show = "select"
        }
        if (field.type === 'text'){
            show="textarea"
        }

    function renderSelectOptions(){
        //Review Pending
        if(field.options === 'state'){
            return selectOptions[field.id] || []
        }
        else{
            return field.options
        }
    }
        return (
            <div key={field.id} className={className}>
                {field.label &&
                <sub>{field.label}</sub>
                }
                <Field
                    name={field.id}
                    type={type}
                    as={show}
                    className="form-control"
                    min={field.type === 'date' ? new Date().toISOString().slice(0,10):null}
                    placeholder={field.placeholder}
                    children={field.type ==='select' ? renderSelectOptions().map(function(option){
                        return <option key={option.id} value={option.id}> {option.name} </option>
                    }):null}
                    />
                        
                {errors[field.id] && touched[field.id] ? (
                    <sub className="required-field">{errors[field.id]}</sub>
                ) : null}

            </div>

        )
    }

    function getField(field_name){
        
        return fields.filter(function(field){return field.id === field_name})[0]
    }

    function getSelectLabel(field, value){

        if(Array.isArray(field.options)){
            return field.options.filter(function(option){return option.id === value})[0].name
        }
        else{
            return selectOptions[field.id].filter(function(option){return parseInt(option.id) === parseInt(value)})[0].name
            
        }

    }

    async function sendForm(values){
        let res = await ws.Post(values,'/api/kalenis_web/send_email')

       
        if(res.status === true){
            props.setMessage({title:'Muchas Gracias', body:"Nos pondremos en contacto a la brevedad."})
           
        }
        else{
            props.setMessage({title:'Ha ocurrido un error', body:"Por favor inténtelo nuevamente o contáctenos en info@kalenislims.com"})
        }

        props.setLoading(false)
        
        
        
    }


    function submitForm(values){

        let submit_values = {}
        let formatted_values = {...values}
        

        Object.keys(formatted_values).forEach(function(field_name){
            let field = getField(field_name)
            if(field.type === 'select'){
                formatted_values[field_name] = getSelectLabel(field, formatted_values[field_name])
            }
            if(field.type === 'date'){
                
                formatted_values[field_name] = moment(formatted_values[field_name]).format('DD-MM-YYYY')

            }
        })

        submit_values.origin = config[props.form_type].title
        submit_values.email = values.email
        submit_values.body = {...formatted_values}

        
        props.setLoading(true)

        sendForm(submit_values)


        ReactGA.event(createConversionEvent(values.laboratory_type));
        


        

    }


    return (


        <div className="form-container">
            
            <div>
                
                {validation &&
                    <Formik
                        initialValues={getInitialValues()}
                        validationSchema={validation}
                        
                        onSubmit={values => {
                            // same shape as initial values
                           submitForm(values);
                        }}
                    >
                        {({ errors, touched }) => (
                            <Form>
                                <div className="row">
                                    {fields.map((field) => (
                                        createField(field, errors, touched)
                                    ))}
                                </div>

                                <div className="text-right">
                                <button className="btn-action btn-md" type="submit">Enviar</button>
                                </div>

                                
                            </Form>
                        )}
                    </Formik>
                }

            </div>
        </div>


    );
}

export default MultiForm;
